<template>
  <div class="view wallet-view">
    <HeaderBar>
      <router-link to="/my/transaction">
        <span class="money-detail-text">资金明细</span>
      </router-link>
    </HeaderBar>
    <div class="balance-wrap">
      <div class="balance">
        <span class="sub-title">可用余额（友绿币）</span>
        <span class="title">{{ balance }}</span>
      </div>
    </div>
    <div class="pay-wrap">
      <div class="title">
        <img class="money-img" src="../../assets/images/charge.png" />
        <span>选择充值金额</span>
      </div>
      <div class="payment-list">
        <div class="payment-item" :class="{'is-odd': index % 2 === 0}" v-for="(item, index) in paymentList" :key="item.id" @click="onPaymentItemClick(item)">
          <span class="price-text">{{`${item.money}元`}}</span>
          <span class="text--sub">{{`${item.money}友绿币`}}</span>
        </div>
      </div>
    </div>
    <!-- <div class="title">友绿币获取</div> -->
    <!-- <div class="form-wrap">
      <input class="price-ipt" placeholder="请输入充值金额" />
      <van-button class="price-btn" type="primary" size="mini">确定</van-button>
    </div>
    <div class="pay-wrap">
      <div class="title">
        <img class="money-img" src="" />
        <span>我的充值账户</span>
      </div>
      <div class="table">
        <div class="table__row">
          <span class="left">支付渠道</span>
          <span class="right">
            <img />
            <span>支付宝</span>
            <img src="../../assets/images/down.png" />
          </span>
        </div>
        <div class="table__row">
          <span class="left"></span>
          <span class="right">
            <img />
            <span>微信</span>
            <img src="../../assets/images/down.png" />
          </span>
        </div>
      </div>
    </div> -->
    <div class="tip-wrap text--sub">
      <div class="title">充值规则</div>
      <ol class="tip">
        <li>充值后将以1:1的兑换比例自动兑换成友绿币，并只用于购买APP内虚拟内容，友绿币不会过期但无法提现。</li>
        <li>充值后如需开具发票请联系我们客服，微信号：wiigreen  </li>
        <li>如从事违反国家法律的行为，将被冻结账户，我们将保留提交公司机关的权利。</li>
      </ol>
    </div>
    <div v-show="showMask" class="mask" @click="showMask=false">
      <div class="content" @click.stop="()=>{return false}">
        <div class="title">确认付款</div>
        <div class="price">{{`￥${selPayment.money}`}}</div>
        <van-radio-group class="method-list" v-model="selMethod">
          <van-cell-group>
            <van-cell class="method-item" clickable @click="selMethod = 2">
              <template slot="title">
                <img class="method-img" src="../../assets/images/alipay.png"/>
                <span>支付宝</span>
              </template>
              <van-radio slot="right-icon" :name="2" />
            </van-cell>
            <van-cell  class="method-item" clickable @click="selMethod = 3">
              <template slot="title">
                <img class="method-img" src="../../assets/images/wechat.png"/>
                <span>微信</span>
              </template>
              <van-radio slot="right-icon" :name="3" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-button class="pay-btn" type="primary" @click="submitPayClick">立即付款</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Radio, RadioGroup, Cell, CellGroup } from 'vant';
import apiUtil from '../../utils/apiUtil';
import {isAndroid_Ios} from '../../utils/jsappUtil';
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
import { Toast } from 'mint-ui';
export default {
  name: 'wallet',
  components: {
    'van-button': Button,
    'van-radio': Radio,
    'van-radio-group': RadioGroup,
    'van-cell': Cell,
    'van-cell-group': CellGroup,
    HeaderBar
  },
  data() {
    return {
      balance: 0.0,
      paymentList: [],
      selPayment: {},
      showMask: false,
      selMethod: 2,
      itemid:0,
      applePay:['','youLv18','youLv98','youLv288','youLv588','youLv998','youLv1998'],
    };
  },
  created() {
    this.init();
    this.getPayment();

    window.applePurchase = (response) => {
            this.applePurchase(response)
    }

  },
  mounted(){
    window.alifailed = this.alifailed;
    window.alisuccess = this.alisuccess;
    window.wxfailed = this.wxfailed;
    window.wxsuccess = this.wxsuccess;
  },
  methods: {
    async applePurchase(response){
    var str=eval("(" + response + ")");
    let transaction_id =str.transaction_id,
        receipt_data =str.receipt_data,
        product_id =str.product_id;
        const res =await apiUtil.post(apiConst.applePurchase, {
               receipt_data:receipt_data,
                product_id: product_id,
               transaction_id:transaction_id
          })
          if(res.success){
            Toast('支付成功');
            //var buy_price = product_id.replace(/[^0-9]/ig,"");
            //this.balance =parseInt(this.balance)+parseInt(buy_price);
            this.init();
           }else{
            Toast('支付失败');
           }


      
    },
    async init() {
      const res = await apiUtil.post(apiConst.getProfile);
      if (res.success) {
        const { integration } = res;
        this.balance = integration;
      }
    },

    async getPayment(){
      const res = await apiUtil.post(apiConst.getPayment);
      if(res.success){
        this.paymentList = res.list;
      }
    },

      onPaymentItemClick(item){
      this.selPayment = item;
      this.itemid = item.id;
      if(isAndroid_Ios()=='android'){
          this.showMask = true;
      }else if(isAndroid_Ios()=='ios'){
        this.showMask = false;
        let payProductID = this.itemid.toString();
        //Toast(this.applePay[payProductID]);
        window.HostApp.callWXpay(this.applePay[payProductID]);
      }
    },
    async submitPayClick(){
      const res = await apiUtil.post(apiConst.submitPayment, {
        pay_type: this.selMethod,
        // amount: this.selPayment.money
        option_id: this.itemid
      })
      let aliPayInfo='';
      let wxType = '';
      if(res.success){
        // todo: app
        console.log(res)
        aliPayInfo = res.payStatus.info.redirectUrl;
        wxType = res.wechat;
      }
      if(isAndroid_Ios()=='android'){
        if(this.selMethod==2){
          this.showMask=false;
          window.HostApp.callAlipay(aliPayInfo,'alifailed','alisuccess');
        }else{
          this.showMask=false;
          window.HostApp.callWXpay(wxType,'wxfailed','wxsuccess');
        }
      }
    },
    alifailed(error){
      // Toast(error)
    },
    alisuccess(result){
      // Toast(result)
      this.init();
    },
    wxfailed(error){
      // Toast(error)
    },
    wxsuccess(result){
      // Toast(result)
      this.init();
    }
  }
};
</script>
<style lang="stylus" scoped>

.wallet-view{
  .money-detail-text{
    color: #333;
  }
  .balance-wrap{
    position: relative;
    height: 224px;
    background:linear-gradient(180deg,rgba(241,241,241,1) 0%,rgba(241,241,241,0) 100%);

    .balance {
      position:absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width:680px;
      height:180px;
      background:linear-gradient(180deg,rgba(194,227,64,1) 0%,rgba(143,195,30,1) 100%);
      box-shadow:0px 18px 26px -16px rgba(143,195,30,1);
      border-radius:10px;
      color: #fff;
      .sub-title {
        font-size: 32px;
        margin-bottom: 15px;
      }
      .title {
        font-size: 46px;
      }
    }


  }

  .form-wrap{
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    background:rgba(143,195,30, .2);

    .price-ipt {
      flex: 1;
      height: 59px;
      padding-left: 12px
      border-radius: 9px;
    }

    .price-btn {
      margin-left: 80px;
      width: 96px;
      height:53px;
      background:linear-gradient(180deg,rgba(180,236,81,1) 0%,rgba(66,147,33,1) 100%);
      border-radius: 9px;
    }
  }

  .pay-wrap {
    padding: 60px 36px 0;
    .money-img {
      width: 64px;
      height: 64px;
    }

    .title {
      display: flex;
      align-items: center;
      color: #8FC31E;
      font-size: 32px;
    }

    .payment-item {
      display: inline-block;
      text-align: center;
      margin: 15px 0;
      width:324px;
      height:165px;
      background:rgba(245,245,245,1);
      border-radius:8px;
      border:1px solid rgba(204,204,204,1);
      &.is-odd{
        margin-right: 30px;
      }
      .price-text {
        display: block;
        font-size: 40px;
        color: #333;
        margin: 35px 0 15px;
      }
    }

    .table {
      margin-top: 30px;
      border: 1px solid #D5D5D5;
      .table__row {
        height: 63px;
        padding: 0 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:not(:last-child){
          border-bottom: 1px solid #D5D5D5;
        }
        .right {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .tip-wrap {
    width: 600px;
    margin: 85px auto 0;
    .title {
      text-align: center;
      font-size: 28px
      margin-bottom: 38px;
    }
    .tip {
      font-size: 22px;
      display: block;
      width: 100%;
      line-height: 50px;
      border: none;
    }
  }

  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,.7);

    .content {
      position: absolute;
      width: 100%;
      height: 807px;
      left: 0;
      bottom: 0;
      background-color: #fff;

      .title {
        height: 84px;
        line-height: 84px;
        font-weight: bold;
        font-size: 32px;
        text-align: center;
        border-bottom: 1PX solid #eee;
      }

      .price {
        height: 163px;
        line-height: 163px;
        font-weight: bold;
        font-size: 43px;
        text-align: center;
        border-bottom: 1PX solid #eee;
      }

      .method-list {
        .method-item {
          height: 118px;
          padding: 0 37px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1PX solid #eee;

          .van-cell__title {
            display: flex;
            align-items center;
            .method-img {
              width: 60px
              height: 60px;
              margin-right: 25px;
            }
          }
        }
      }

      .pay-btn {
        position: absolute;
        bottom: 50px;
        left: 50%;
        margin-left: -243px;
        width: 485px;
        height: 90px;
        font-size: 32px;
      }
    }
  }
}
</style>
